import * as api from "./ApiBase";

export async function GetAdminEmails() {
  return await api.Get("/api/GetAdminEmails");
}

export async function AddAdminEmail(email) {
  return await api.Post(
    `/api/AddAdminEmail?email=${encodeURIComponent(email)}`
  );
}

export async function RemoveAdminEmail(email) {
  return await api.Post(
    `/api/RemoveAdminEmail?email=${encodeURIComponent(email)}`
  );
}

export async function GetAllEmployees() {
  return await api.Get("/api/GetAllEmployees");
}

export async function GetEmployeeStats() {
  return await api.Get("/api/GetEmployeeStats");
}

export async function SetAdminRole(email, role) {
  return await api.Post(
    `/api/SetAdminRole?email=${encodeURIComponent(email)}&role=${encodeURIComponent(role)}`
  );
}

export async function GetGeneric(path) {
  return await api.Get(path);
}

export async function GetEmployeeResume(employeeId, resumeId) {
  return await api.Get(
    `/api/GetEmployeeResume?employeeId=${encodeURIComponent(
      employeeId
    )}&resumeId=${encodeURIComponent(resumeId)}`
  );
}

export async function GetAllowlist() {
  return await api.Get("/api/GetAllowlist");
}

export async function AddToAllowlist(data) {
  return await api.Post("/api/AddToAllowlist", data);
}

export async function RemoveFromAllowlist(entryId) {
  return await api.Post(
    `/api/RemoveFromAllowlist?entryId=${encodeURIComponent(entryId)}`
  );
}

export async function GetBlocklist() {
  return await api.Get("/api/GetBlocklist");
}

export async function AddToBlocklist(data) {
  return await api.Post("/api/AddToBlocklist", data);
}

export async function RemoveFromBlocklist(entryId) {
  return await api.Post(
    `/api/RemoveFromBlocklist?entryId=${encodeURIComponent(entryId)}`
  );
}

export async function DeactivateUser(data) {
  return await api.Post("/api/DeactivateUser", data);
}

export async function ReactivateUser(entryId) {
  return await api.Post(
    `/api/ReactivateUser?entryId=${encodeURIComponent(entryId)}`
  );
}

export async function GetDeactivatedUsers() {
  return await api.Get("/api/GetDeactivatedUsers");
}

export async function GetAdminAuditLog(actionType, targetUser, maxEntries, startDate, endDate) {
  let url = "/api/GetAdminAuditLog";
  const params = [];
  if (actionType) params.push(`actionType=${encodeURIComponent(actionType)}`);
  if (targetUser) params.push(`targetUser=${encodeURIComponent(targetUser)}`);
  if (maxEntries) params.push(`maxEntries=${encodeURIComponent(maxEntries)}`);
  if (startDate) params.push(`startDate=${encodeURIComponent(startDate)}`);
  if (endDate) params.push(`endDate=${encodeURIComponent(endDate)}`);
  if (params.length > 0) url += "?" + params.join("&");
  return await api.Get(url);
}

export async function LogAdminAction(data) {
  return await api.Post("/api/LogAdminAction", data);
}

export async function GetAllUsersWithStatus() {
  return await api.Get("/api/GetAllUsersWithStatus");
}

export async function CheckUserConflicts(email, action) {
  let url = `/api/CheckUserConflicts?email=${encodeURIComponent(email)}`;
  if (action) url += `&action=${encodeURIComponent(action)}`;
  return await api.Get(url);
}
